
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/accounts',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/accounts/',
            getPage: () => import(
              /* webpackChunkName: "accounts" */
              '/work/account-docs/_site_tmp/_accounts.js'
            ),
            
            
          },{
            path: '/accounts/guides/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides" */
              '/work/account-docs/_site_tmp/_accounts_guides.js'
            ),
            
            
          },{
            path: '/accounts/guides/invoices/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-invoices" */
              '/work/account-docs/_site_tmp/_accounts_guides_invoices.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/sections/hybrid-frameworks/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing-sections-hybrid-frameworks" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing_sections_hybrid-frameworks.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/sections/mobile-applications/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing-sections-mobile-applications" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing_sections_mobile-applications.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/sections/third-party-tools/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing-sections-third-party-tools" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing_sections_third-party-tools.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/sections/web-maps/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing-sections-web-maps" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing_sections_web-maps.js'
            ),
            
            
          },{
            path: '/accounts/guides/pricing/sections/web-services-apis/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-pricing-sections-web-services-apis" */
              '/work/account-docs/_site_tmp/_accounts_guides_pricing_sections_web-services-apis.js'
            ),
            
            
          },{
            path: '/accounts/guides/settings/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-settings" */
              '/work/account-docs/_site_tmp/_accounts_guides_settings.js'
            ),
            
            
          },{
            path: '/accounts/guides/statistics/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-statistics" */
              '/work/account-docs/_site_tmp/_accounts_guides_statistics.js'
            ),
            
            
          },{
            path: '/accounts/guides/tokens/',
            getPage: () => import(
              /* webpackChunkName: "accounts-guides-tokens" */
              '/work/account-docs/_site_tmp/_accounts_guides_tokens.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };